import axios from "axios";
import store from "@/store/index";
import app from "@/main";

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

if (store.getters.isLoggedIn) {
  httpClient.defaults.headers.common["Authorization"] = store.getters.token;
}

httpClient.interceptors.request.use((config) => {
  app.config.globalProperties.$loading.value = true;
  return config;
});

httpClient.interceptors.response.use(
  (response) => {
    app.config.globalProperties.$loading.value = false;
    return response;
  },
  (error) => {
    app.config.globalProperties.$loading.value = false;
    if (error.response.status === 401) {
      store.dispatch("logout");
    }
    return Promise.reject(error);
  }
);

export default httpClient;
